module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"nl-BE":{"show_info":"Toon gebouwinformatie"},"en-BE":{"show_info":"Show building information"},"fr-BE":{"show_info":"Montrer les informations du bâtiment"}}')
  delete Component.options._Ctor
}
